export default __webpack_public_path__ + "3da75b5318ab0ad6d1b890fd3dcf9fb4.jpg";